/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 *
 * @flow
 */

'use strict';

import UnimplementedView from './UnimplementedView';

export default UnimplementedView;
